import React from "react";

interface ErrorStateProps {
  onGoBack?: () => void;
  errorMessage?: string;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  onGoBack = () => window.history.back(),
  errorMessage = "Failed to load purchase order details",
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <p className="text-red-600 mb-4">{errorMessage}</p>
        <button
          onClick={onGoBack}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Go Back
        </button>
      </div>
    </div>
  );
};
